export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_06.4d1d2125.jpg";